import EffectChainEditorContainer from './EffectChainEditorContainer';

export default EffectChainEditorContainer;
